module.exports = __webpack_public_path__ + "87e95cc73f2b1252db953259f1c7fc84.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-stripes-purple-s.png
// module id = 1381
// module chunks = 0